import { styled } from '@mui/material'
import { mobile } from '../../../../../utils/breakpoints'

export const StyledIcon = styled('svg')`
  font-size: 40px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.branding.footerText};
  margin-right: 15px;
  transition:
    color 0.3s,
    transform 0.3s;

  &:hover {
    color: ${({ theme }) => theme.palette.branding.footerTextHover};
  }

  ${({ theme }) => mobile(theme, { 'font-size': '30px' })}
`
